import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20a8ffce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ftl-bid" }
const _hoisted_2 = { class: "ftl-bid__container" }
const _hoisted_3 = { class: "container__slot" }
const _hoisted_4 = { class: "container__statuses" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_enter_cost_to_be_paid = _resolveComponent("enter-cost-to-be-paid")!
  const _component_enter_carrier_data = _resolveComponent("enter-carrier-data")!
  const _component_enter_cost_price = _resolveComponent("enter-cost-price")!
  const _component_enter_comment = _resolveComponent("enter-comment")!
  const _component_enter_cancel_reason = _resolveComponent("enter-cancel-reason")!
  const _component_ftl_bid_state = _resolveComponent("ftl-bid-state")!
  const _component_bids_form_ftl = _resolveComponent("bids-form-ftl")!
  const _component_ftl_bid_header = _resolveComponent("ftl-bid-header")!
  const _component_ftl_bid_tabs = _resolveComponent("ftl-bid-tabs")!
  const _component_ftl_bid_general = _resolveComponent("ftl-bid-general")!
  const _component_ftl_bid_cargo_information = _resolveComponent("ftl-bid-cargo-information")!
  const _component_ftl_bid_payment = _resolveComponent("ftl-bid-payment")!
  const _component_ftl_bid_waypoints = _resolveComponent("ftl-bid-waypoints")!
  const _component_ftl_bid_car = _resolveComponent("ftl-bid-car")!
  const _component_ftl_bid_files = _resolveComponent("ftl-bid-files")!
  const _component_ftl_bid_statuses = _resolveComponent("ftl-bid-statuses")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_enter_cost_to_be_paid)
      ? (_openBlock(), _createBlock(_component_enter_cost_to_be_paid, {
          key: 0,
          "is-loading": _ctx.state.is_enter_cost_to_be_paid_loading,
          "ftl-type": _ctx.state.ftlBid?.ftl_type,
          "rate-type": _ctx.state.ftlBid?.payment_rate_type_id,
          onSubmitted: _ctx.enterCostToBePaidSubmit,
          onCancel: _ctx.enterCostToBePaidCancel
        }, null, 8, ["is-loading", "ftl-type", "rate-type", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_enter_carrier_data)
      ? (_openBlock(), _createBlock(_component_enter_carrier_data, {
          key: 1,
          "ftl-type": _ctx.state.ftlBid?.ftl_type,
          "shipment-type": _ctx.state.ftlBid?.shipment_type,
          "is-need-car": _ctx.state.ftlBid?.is_need_car,
          onSubmitted: _ctx.enterCarrierDataSubmit,
          onCancel: _ctx.enterCarrierDataCancel
        }, null, 8, ["ftl-type", "shipment-type", "is-need-car", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_enter_cost_price)
      ? (_openBlock(), _createBlock(_component_enter_cost_price, {
          key: 2,
          "ftl-type": _ctx.state.ftlBid?.ftl_type,
          "is-need-car": _ctx.state.ftlBid?.is_need_car,
          loading: _ctx.state.is_enter_cost_price_loading,
          onSubmitted: _ctx.enterCostPriceSubmit,
          onCancel: _ctx.enterCostPriceCancel
        }, null, 8, ["ftl-type", "is-need-car", "loading", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_enter_comment)
      ? (_openBlock(), _createBlock(_component_enter_comment, {
          key: 3,
          "is-loading": _ctx.state.is_enter_comment_loading,
          onSubmitted: _ctx.enterCommentSubmit,
          onCancel: _ctx.enterCommentCancel
        }, null, 8, ["is-loading", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_cancel_bid)
      ? (_openBlock(), _createBlock(_component_enter_cancel_reason, {
          key: 4,
          onSubmitted: _ctx.cancelBidSubmit,
          onCancel: _ctx.cancelBidCancel
        }, null, 8, ["onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_ftl_bid_state, {
          key: 5,
          "is-loading": _ctx.state.is_loading,
          "is-failed": _ctx.state.is_failed,
          onRetry: _ctx.loadFtlBid
        }, null, 8, ["is-loading", "is-failed", "onRetry"]))
      : (_ctx.state.is_create_bid && _ctx.state.ftlBid)
        ? (_openBlock(), _createBlock(_component_bids_form_ftl, {
            key: 6,
            class: "mt-6",
            "ftl-bid": _ctx.state.ftlBid,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_create_bid = false)),
            onAdded: _ctx.onBidAdded
          }, null, 8, ["ftl-bid", "onAdded"]))
        : (_ctx.state.ftlBid)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _createVNode(_component_ftl_bid_header, {
                "status-id": _ctx.state.ftlBid.status_id,
                "status-code": _ctx.state.ftlBid.status_code,
                "status-name": _ctx.state.ftlBid.status_name,
                "ftl-type": _ctx.state.ftlBid.ftl_type,
                "bid-id": _ctx.state.ftlBid.id,
                "order-id": _ctx.state.ftlBid.order_id,
                "is-status-changing": _ctx.state.is_status_changing,
                "is-enter-cost-to-be-paid-loading": _ctx.state.is_enter_cost_to_be_paid_loading,
                "is-enter-carrier-data-loading": _ctx.state.is_enter_carrier_data_loading,
                "is-enter-cost-price-loading": _ctx.state.is_enter_cost_price_loading,
                "is-enter-comment-loading": _ctx.state.is_enter_comment_loading,
                "is-document-loading": _ctx.state.is_document_loading,
                "is-download-loading": _ctx.state.is_download_loading,
                "is-invoices-printing": _ctx.state.is_invoices_printing,
                "logist-bid": _ctx.state.ftlBid.logist_bid,
                onAcceptInWork: _ctx.onAcceptInWork,
                onEnterCostToBePaid: _ctx.onEnterCostToBePaid,
                onRepeatCalculateCost: _ctx.onRepeatCalculateCost,
                onEnterCarrierData: _ctx.onEnterCarrierData,
                onEnterCostPrice: _ctx.onEnterCostPrice,
                onEnterComment: _ctx.onEnterComment,
                onCancelBid: _ctx.onCancelBid,
                onPrintInvoices: _ctx.onPrintInvoices,
                onDocument: _ctx.sendD24,
                onDownload: _ctx.downloadLogistBid
              }, null, 8, ["status-id", "status-code", "status-name", "ftl-type", "bid-id", "order-id", "is-status-changing", "is-enter-cost-to-be-paid-loading", "is-enter-carrier-data-loading", "is-enter-cost-price-loading", "is-enter-comment-loading", "is-document-loading", "is-download-loading", "is-invoices-printing", "logist-bid", "onAcceptInWork", "onEnterCostToBePaid", "onRepeatCalculateCost", "onEnterCarrierData", "onEnterCostPrice", "onEnterComment", "onCancelBid", "onPrintInvoices", "onDocument", "onDownload"]),
              _createVNode(_component_ftl_bid_tabs, {
                value: _ctx.state.currentTab,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.currentTab) = $event)),
                "status-id": _ctx.state.ftlBid.status_id,
                "invoice-files": _ctx.state.ftlBid.invoice_files,
                "certificate-files": _ctx.state.ftlBid.certificate_of_safety_files
              }, null, 8, ["value", "status-id", "invoice-files", "certificate-files"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.state.currentTab === 'general')
                    ? (_openBlock(), _createBlock(_component_ftl_bid_general, {
                        key: 0,
                        "is-need-car": _ctx.state.ftlBid.is_need_car,
                        "company-name": _ctx.state.ftlBid.company_name,
                        "user-name": _ctx.state.ftlBid.user_name,
                        "logist-name": _ctx.state.ftlBid.logist_name,
                        "take-date": _ctx.state.ftlBid.take_date,
                        "take-time": _ctx.state.ftlBid.take_time,
                        "ftl-type-name": _ctx.state.ftlBid.ftl_type_name,
                        "manager-name": _ctx.state.ftlBid.manager_name,
                        "shipment-type-name": _ctx.state.ftlBid.shipment_type_name
                      }, null, 8, ["is-need-car", "company-name", "user-name", "logist-name", "take-date", "take-time", "ftl-type-name", "manager-name", "shipment-type-name"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'cargo-information')
                    ? (_openBlock(), _createBlock(_component_ftl_bid_cargo_information, {
                        key: 1,
                        description: _ctx.state.ftlBid.description,
                        "car-info": _ctx.state.ftlBid.car_info,
                        height: _ctx.state.ftlBid.height,
                        width: _ctx.state.ftlBid.width,
                        places: _ctx.state.ftlBid.places,
                        "transport-type-name": _ctx.state.ftlBid.transport_type_name,
                        insurance: _ctx.state.ftlBid.insurance,
                        "dop-order-number": _ctx.state.ftlBid.dop_order_number,
                        length: _ctx.state.ftlBid.depth,
                        weight: _ctx.state.ftlBid.weight,
                        "is-stacked": _ctx.state.ftlBid.is_stacked,
                        "declared-price": _ctx.state.ftlBid.declared_price,
                        "special-conditions": _ctx.state.ftlBid.special_conditions,
                        "cargo-name": _ctx.state.ftlBid.cargo_name,
                        "is-dangerous": _ctx.state.ftlBid.is_dangerous,
                        "ftl-type": _ctx.state.ftlBid.ftl_type,
                        "hs-code": _ctx.state.ftlBid.hs_code,
                        "customs-clearance": _ctx.state.ftlBid.customs_clearance,
                        packaging: _ctx.state.ftlBid.packaging
                      }, null, 8, ["description", "car-info", "height", "width", "places", "transport-type-name", "insurance", "dop-order-number", "length", "weight", "is-stacked", "declared-price", "special-conditions", "cargo-name", "is-dangerous", "ftl-type", "hs-code", "customs-clearance", "packaging"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'payment')
                    ? (_openBlock(), _createBlock(_component_ftl_bid_payment, {
                        key: 2,
                        "cost-price-with-nds": _ctx.state.ftlBid.cost_price_with_nds,
                        "ftl-type": _ctx.state.ftlBid.ftl_type,
                        "payment-rate-type-id": _ctx.state.ftlBid.payment_rate_type_id,
                        "cost-price-per-hour": _ctx.state.ftlBid.cost_price_per_hour,
                        "cost-price": _ctx.state.ftlBid.cost_price,
                        "payment-method-name": _ctx.state.ftlBid.payment_method_name,
                        "paid-price": _ctx.state.ftlBid.paid_price,
                        "is-prepayment": _ctx.state.ftlBid.is_prepayment,
                        "custom-payment": _ctx.state.ftlBid.custom_payment
                      }, null, 8, ["cost-price-with-nds", "ftl-type", "payment-rate-type-id", "cost-price-per-hour", "cost-price", "payment-method-name", "paid-price", "is-prepayment", "custom-payment"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'stops')
                    ? (_openBlock(), _createBlock(_component_ftl_bid_waypoints, {
                        key: 3,
                        waypoints: _ctx.state.ftlBid.waypoints,
                        "bid-id": Number(_ctx.$route.params.id)
                      }, null, 8, ["waypoints", "bid-id"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'car')
                    ? (_openBlock(), _createBlock(_component_ftl_bid_car, {
                        key: 4,
                        "carrier-name": _ctx.state.ftlBid.carrier_name,
                        "car-brand": _ctx.state.ftlBid.car_brand,
                        "car-number": _ctx.state.ftlBid.car_number,
                        "driver-name": _ctx.state.ftlBid.driver_name,
                        "driver-phone": _ctx.state.ftlBid.driver_phone,
                        "driver-id-number": _ctx.state.ftlBid.driver_id_number,
                        "driver-license-number": _ctx.state.ftlBid.driver_license_number,
                        "trailer-license-number": _ctx.state.ftlBid.trailer_license_number
                      }, null, 8, ["carrier-name", "car-brand", "car-number", "driver-name", "driver-phone", "driver-id-number", "driver-license-number", "trailer-license-number"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'files')
                    ? (_openBlock(), _createBlock(_component_ftl_bid_files, {
                        key: 5,
                        "invoice-files": _ctx.state.ftlBid.invoice_files,
                        "certificate-files": _ctx.state.ftlBid.certificate_of_safety_files
                      }, null, 8, ["invoice-files", "certificate-files"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ftl_bid_statuses, {
                    statuses: _ctx.state.ftlBid.bid_statuses
                  }, null, 8, ["statuses"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
  ]))
}